import { render, staticRenderFns } from "./ConfirmUserRelationAsChild.vue?vue&type=template&id=6fe8baf6&scoped=true&"
import script from "./ConfirmUserRelationAsChild.vue?vue&type=script&lang=js&"
export * from "./ConfirmUserRelationAsChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe8baf6",
  null
  
)

export default component.exports